import { PUBLIC_INSURANCES } from '@flows/configs/de/publicHealth/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PublicHealthStepParams } from './types'
import { previousInsurerSchema } from './types'

export const previousInsurer = (params: PublicHealthStepParams) => {
  const schema = previousInsurerSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_publicHealth:steps.previous_insurer.title',
        },
      },
      {
        type: 'dropDown',
        styleType: 'outlined',
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_publicHealth:steps.previous_insurer.dropdown',
        },
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.previous_insurer.not_insured',
            },
            value: 'not_insured',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.previous_insurer.not_on_list',
            },
            value: 'insurerer_not_listed',
          },
          ...PUBLIC_INSURANCES.map((insurance) => ({
            label: {
              type: 'nonTranslatableText' as const,
              text: insurance.name,
            },
            value: insurance.key,
          })),
        ],
        name: params.helperFunctions.getParamPath('previous_insurer'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'employment_status',
    subFlow: SubFlow.PublicHealth,
  } as const satisfies AnyStepConfiguration
}
